import { render, staticRenderFns } from "./qita.vue?vue&type=template&id=1ccdf59a&scoped=true"
var script = {}
import style0 from "./qita.vue?vue&type=style&index=0&id=1ccdf59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccdf59a",
  null
  
)

export default component.exports